import Vue from 'vue'
import App from './App.vue'
import createRouter from './router/index'
import createStore from './store/index'
import {sync} from "vuex-router-sync";
import MetaInfo from 'vue-meta-info';

import commonInstall from 'utils/js/commonInstall'//通用工具
import ElementUI from 'element-ui';//ui框架
// import Croppa from 'vue-croppa'//截图插件
// import 'amfe-flexible'//px转rem
// import 'element-ui/lib/theme-chalk/index.css';
import 'utils/css/theme/index.css';
import 'utils/css/elementOften.less';
import 'utils/css/general.less';
import 'assets/iconfont/iconfont.css';
import "animate.css"

Vue.config.productionTip = false
Vue.use(commonInstall);
Vue.use(ElementUI);
// Vue.use(Croppa);
Vue.use(MetaInfo);

Vue.config.productionTip = false

//多行溢出问题
Vue.filter('omitValue', function (value, num) {
  // let agent = navigator.userAgent.toLowerCase();
  // if (agent.indexOf("chrome") == '-1') {
  //   if (value&&value.length >= num) {
  //     return value.slice(0, num) + '...';
  //   }
  // }
  return value;
})

// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')


//ssr修改-zl
export function createApp() {
  // 创建 router 
  const router = createRouter();
  const store= createStore();

  // 同步路由状态(route state)到 store
  sync(store, router);

  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  });
  return { app, router,store};
}